<template>
  <v-dialog v-model="value" max-width="760" persistent scrollable>
    <v-card>
      <v-toolbar dark color="#3a6861" elevation="0">
        <v-toolbar-title><h4>{{titulo}}</h4></v-toolbar-title>
        <v-spacer/>
        <v-btn class="close__button" text @click="fecharModal" icon>
          <v-icon>close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text class="modal-banner-container">
        <iframe width="720" height="450" :src="link">
        </iframe>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'ModalBanner',
  props: {
    value: Boolean,
    titulo: String,
    link: String
  },
  methods: {
    fecharModal() {
      this.$emit('fecharModalBanner')
    },
  }
}
</script>

<style scoped lang="stylus">

.modal-banner-container
  overflow-x hidden
  text-align center
  padding 20px

</style>
